export const MAIN_LOGO = '/logo_main.jpeg';
export const AUTH_BANNER = '/hero_login.jpeg';
